import {Box, Flex} from '@chakra-ui/react';
import {FC} from 'react';
import LinkUI from 'ui/LinkUI';
import NextImageUI from 'ui/NextImage';

interface IProps {
  isDesktop: boolean;
}

export const MetroLogo: FC<IProps> = ({isDesktop}) => {
  const logo = '/metro.svg';

  return (
    <LinkUI href="/metro">
      <Flex as="a" flexDirection="column">
        <Flex alignItems="center">
          {isDesktop ? (
            <NextImageUI width={146} height={45} src={logo} alt="Metro logo" />
          ) : (
            <Box width="90px" height="30px">
              <NextImageUI width={146} height={45} src={logo} alt="Metro logo" />
            </Box>
          )}
        </Flex>
      </Flex>
    </LinkUI>
  );
};
